import Swiper from 'swiper';

import 'swiper/css/pagination';
import 'swiper/css';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

const sections = document.querySelectorAll('section.customer-stories');

sections.forEach(section => {
	const swiperEl = section.querySelector('.swiper');
	const prevEl = section.querySelector('[data-next]');
	const nextEl = section.querySelector('[data-prev]');

	if (swiperEl) {
		new Swiper(swiperEl, {
			modules: [Navigation, Pagination, EffectFade],
			direction: 'horizontal',
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			loop: true,
			autoHeight: true,
			pagination: {
				el: section.querySelector('[data-pager]'),
				enabled: true,
				type: 'fraction',
				renderFraction: (currentClass, totalClass) => `
					<span class="${currentClass}"></span> / <span class="${totalClass}"></span>
				`,
			},
			navigation: {
				prevEl,
				nextEl,
			},
		});
	}
});
